import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { Network } from '@capacitor/network';
import { Observable, of, merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
// import { NetworkService } from '../services/network.service';
import { RestService } from '../services/rest.service';
import { SessionService } from '../services/session.service';
import { ToastrService } from '../services/toastr.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  public req: HttpRequest<any> = null;

  constructor(private restService: RestService,
    private sessionService: SessionService,
    private httpClient: HttpClient,
    private toastr: ToastrService,
    private router: Router) {
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            if (event.url != environment.oauthTokenApi && event.url != environment.passwordCheckApi) {
              if (this.sessionService.accessToken) {
                if ((event.url.substr(event.url.lastIndexOf('/') + 1) != "/companies")) {// && ()
                  if (this, this.sessionService.Company) {
                  } else {
                  }
                }
              }
            }
          }
        }, error => {
          this.handleError(error);
        }
      )
    );
  }

  private logout() {
    this.sessionService.clearData();
    this.router.navigate(["/login"]);
  }

  private handleError(error: any) {
    if (error.status && error.status === 401) {
      this.logout();
    } else if (error.status === 400 || error.status === 404) {
      const errorMessage = error.error!.error!.message;
      if (errorMessage) {
        const actualMessage = errorMessage.split('CorrelationId')[0].trim();
        if (actualMessage) {
          this.toastr.error(actualMessage);
        }
      }
    }
  }

  get httpOptions() {
    return {
      headers: new HttpHeaders(
        {
          'apiKey': environment.apiProtectionKey,
        })
    };
  }

  private licensecheck() {
    let payload = this.sessionService.UserLiseceLoginIfo;
    this.httpClient.post(environment.lisenceApiCore + 'CheckSessionValidity', payload, this.httpOptions).subscribe((response: any) => {
      if (response) {
        if (response && response.PassToLogin) {
          this.sessionService.licensePermission = true;
        } else {
          this.toastr.error(response.Message);
          this.logout();
          this.sessionService.licensePermission = false;
        }
      }
    }, error => {
      this.toastr.error('something went wrong pres f5');
    });
  }
}

